import inveAxios from './_inveAxios'
import axios from './_nestAxios'

export const getSocio = _id => inveAxios.get(`/socios/${_id}`)
export const actualizarSocio = (_id, data) => inveAxios.put(`/socios/${_id}`, data)
export const descargarPlantillaImportarSocios = () =>
  inveAxios.get('/socios/descargar/plantilla', {
    responseType: 'blob'
  })
export const getNuevoCodigo = () => inveAxios.get('/socios/nuevo-codigo')
export const nuevoSocio = data => inveAxios.post('/socios', data)
export const obtenerContactosxIdSocioAsSelect = idSocio =>
  inveAxios.get(`/socios/${idSocio}/contactos`, {
    params: {
      tipoConsulta: 'select'
    }
  })
export const obtenerDireccionesxIdSocioAsSelect = idSocio =>
  inveAxios.get(`/socios/${idSocio}/direcciones`, {
    params: {
      tipoConsulta: 'select'
    }
  })
export const importarExcelSocios = data => inveAxios.post('/socios/importar', data)
export const nuevaDireccion = (_idSocio, direccionData) => inveAxios.post(`/socios/${_idSocio}/direcciones`, direccionData)
export const nuevoContactoxIdSocio = (idSocio, contactoData) => inveAxios.post(`/socios/${idSocio}/contactos`, contactoData)

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const nuevoSocioViaVentas = data =>
  inveAxios.post('/socios', data, {
    params: {
      tipoConsulta: 'ventas'
    }
  })

export const nuevoSocioViaCompras = data =>
  inveAxios.post('/socios', data, {
    params: {
      tipoConsulta: 'compras'
    }
  })

export const nuevoSocioViaOtros = data =>
  inveAxios.post('/socios', data, {
    params: {
      tipoConsulta: 'otros'
    }
  })

export const obtenerxIdAsInfoSlim = _id =>
  inveAxios.get(`/socios/${_id}`, {
    params: {
      tipoConsulta: 'slim-info'
    }
  })

export const getSocioViaSunat = ruc => inveAxios.get(`/socios/consulta-ruc/${ruc}`)

export const obtenerClientesxBusquedaAsSelect2 = ({ busqueda }) =>
  inveAxios.get('/socios', {
    params: {
      tipoConsulta: 'select2-cliente',
      busqueda
    }
  })

export const obtenerProveedoresxBusquedaAsSelect2 = ({ busqueda }) =>
  inveAxios.get('/socios', {
    params: {
      tipoConsulta: 'select2-proveedor',
      tipo: 'P',
      busqueda
    }
  })

export const obtenerSociosOtrosxBusquedaAsSelect2 = ({ busqueda }) =>
  inveAxios.get('/socios', {
    params: {
      tipoConsulta: 'select2-otros',
      busqueda
    }
  })

export const obtenerSociosTodosxBusquedaAsSelect2 = ({ busqueda }) =>
  inveAxios.get('/socios', {
    params: {
      tipoConsulta: 'select2-todos',
      busqueda
    }
  })

export const obtenerTituloViaticoxIdAsEdicion = id => axios.get(`/socios/titulos-viaticos/${id}`)

export const obtenerTitulosViaticosxIdSocioAsSelect = idSocio =>
  axios.get('/socios/titulos-viaticos', {
    params: {
      tipoConsulta: 'select',
      idSocio: idSocio
    }
  })

export const nuevoTituloViatico = data => axios.post('/socios/titulos-viaticos', data)

export const nuevoTituloViaticoTrabajador  = data => axios.post('/socios/titulos-viaticos-trabajador', data)

export const actualizarTituloViaticoxId = (id, data) => axios.put(`/socios/titulos-viaticos/${id}`, data)

export const actualizarTituloViaticoxIdTrabajador = (id, data) => axios.put(`/socios/titulos-viaticos-trabajador/${id}`, data)

export const eliminarTituloViaticoxId = id => axios.delete(`/socios/titulos-viaticos/${id}`)
